import {
  POST_LAST_STEP_VISITED_LEAD,
  UPDATE_STEPS_VISITED,
} from '../../constants/ActionTypes'
import { createBasicCreator, fetchData } from '../Buy'

export const updateStepsVisited = createBasicCreator(UPDATE_STEPS_VISITED)

export const postLastStepVisitedLead = (dispatch, getState) => {
  const state = getState()

  const { stepsVisited } = state
  const lastStep =
    (getState().rerouteTo && getState().rerouteTo.replace('/', '')) ||
    window.location.hash.split('/')[1]

  if (stepsVisited.length > 0 && stepsVisited.includes(lastStep)) {
    return Promise.resolve()
  }

  stepsVisited.push(lastStep)
  dispatch(updateStepsVisited(stepsVisited))

  const uri = `${window.brumbrum.url_api}/lead/p/v3/ordine_step_sellout`
  const body = JSON.stringify({
    id_ordine: (state.ordine && state.ordine.id_ordine) || undefined,
    step_carrello: lastStep,
    telefono: (state.customer && state.customer.phone) || undefined,
    email: (state.customer && state.customer.email) || undefined,
    privacy: 'ok',
  })

  return dispatch(
    fetchData(POST_LAST_STEP_VISITED_LEAD)({
      body,
      callback: POST_LAST_STEP_VISITED_LEAD,
      errorMessage: POST_LAST_STEP_VISITED_LEAD,
      method: 'POST',
      uri,
    })
  )
}
